<div class="tabGroupWrapper">
  <mat-tab-group>
    <!-- ROLES TAB -->
    <mat-tab label="Roles">
      <section class="cmn-innerpage-wrapper">
        <div class="inner-content dashboard">
          <div class="head">
            <div class="search-wrapper">
              <input type="text" class="cmn-header-search" placeholder="Search Roles" (input)="onRolesSearch($event)" />
            </div>
            <button class="cmn-add-btn" (click)="openDialog()">
              <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add
              Role
            </button>
          </div>

          <div class="agGrid-wrapper">
            <ag-grid-angular [theme]="'legacy'" style="width: 100%" [rowData]="rowData" [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef" [rowSelection]="rowSelection" [suppressRowClickSelection]="true"
              [pagination]="true" [paginationPageSize]="paginationPageSize"
              [paginationPageSizeSelector]="paginationPageSizeSelector" [class]="themeClass"
              (rowClicked)="onRowclicked($event)">
            </ag-grid-angular>
            <div class="pagination-wrapper">
              <div class="page-size">
                <label for="pageSize">Page Size:</label>
                <select id="pageSize" [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
                  <option *ngFor="let size of pageSizeOptions" [value]="size">
                    {{ size }}
                  </option>
                </select>
              </div>

              <div class="page-nav" *ngIf="totalPages > 1">
                <button class="prev" (click)="prevPage()" [disabled]="page === 0">
                  <img src="assets/images/icons/arrow.svg" alt="prev" />
                </button>
                <span> Page {{ page + 1 }} of {{ totalPages }} </span>
                <button class="next" (click)="nextPage()" [disabled]="page + 1 >= totalPages">
                  <img src="assets/images/icons/arrow.svg" alt="next" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </mat-tab>

    <!-- ADMIN USERS TAB -->
    <mat-tab label="Portal Users" *appHasPermission="'VIEW_USER'">
      <section class="cmn-innerpage-wrapper">
        <div class="inner-content dashboard">

          <div class="head">
            <div class="search-wrapper">
              <input type="text" class="cmn-header-search" placeholder="Search Users"
                (input)="onPortalUsersSearch($event)" />
            </div>

            <button class="cmn-add-btn" *appHasPermission="'ADD_USER'" (click)="openPortalUserDialog()">
              <img src="assets/images/icons/icon-add.svg" alt="Add icon" />
              Add Profile
            </button>
          </div>

          <div class="agGrid-wrapper">
            <ag-grid-angular [theme]="'legacy'" style="width: 100%" [rowData]="users" [columnDefs]="userDefs"
              [defaultColDef]="defaultColDef" [rowSelection]="rowSelection" [suppressRowClickSelection]="true"
              [pagination]="false" [class]="themeClass"></ag-grid-angular>
          </div>

          <!--MOVE PAGINATION HERE-->
          <div class="pagination-wrapper">
            <div class="page-size">
              <label for="userPageSize">Page Size:</label>
              <select id="userPageSize" [(ngModel)]="userPageSize" (change)="onUserPageSizeChange($event)">
                <option *ngFor="let size of userPageSizeOptions" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>

            <div class="page-nav" *ngIf="userTotalPages > 1">
              <button class="prev" (click)="prevUserPage()" [disabled]="userPage === 0">
                <img src="assets/images/icons/arrow.svg" alt="prev" />
              </button>
              <span> Page {{ userPage + 1 }} of {{ userTotalPages }} </span>
              <button class="next" (click)="nextUserPage()" [disabled]="userPage + 1 >= userTotalPages">
                <img src="assets/images/icons/arrow.svg" alt="next" />
              </button>
            </div>
          </div>

        </div>
      </section>
    </mat-tab>

  </mat-tab-group>
</div>
